import { useState } from "react";
import { line, curveNatural, clipPath } from "d3";
import { useEffect } from "react";
export const Entalphy = ({
  data,
  xScale,
  yScale,
  xValue,
  yValue,

  //tooltipFormat,
  enthalpy,
  intersectionPath,
  isSmallScreen,
}) => {
  const [pointsOfItersection, setPoint] = useState({ x: 0, y: 0 });

  var intersect = require("path-intersection");

  //console.log(data);
  //useEffect(() => {
  let druga = line()
    .x((d) => xScale(xValue(d)))
    .y((d) => yScale(yValue(d)))
    .curve(curveNatural)(data.filter((row) => row.enthalpy === enthalpy));
  var intersection = intersect(intersectionPath, druga);
  // setPoint(intersection[0].x, intersection[0].y);
  //intersection.length !== 0 && console.log(intersection);
  /*if (intersection !== undefined)
    setPoint({ x: intersection[0].x, y: intersection[0].y });*/

  // }, [circleRadius]);

  return (
    <g>
      {" "}
      //className="entalphy"
      <path clipPath="url(#clip-path)" fill="none" stroke="#a77c5a" d={druga}>
        <title>{"Enthalpy: " + enthalpy}</title>
      </path>
      {
        //data.map(d => (
        //  <circle cx={xScale(xValue(d))} cy={yScale(yValue(d))} r={circleRadius}>
        //    <title>{tooltipFormat(xValue(d))}</title>
        //  </circle>
        //))
      }
      {intersection.length !== 0 && (
        <text //x="0" y="0">
          fill="#a77c5a"
          font-family="Poppins, sans-serif"
          fontSize={isSmallScreen ? 8 : 16}
          x={intersection[0].x}
          y={intersection[0].y}
          transform={isSmallScreen ? "translate(2 5)" : "translate(2 20)"}
          clipPath="url(#clip-path-square)"
        >
          {" "}
          {enthalpy}{" "}
        </text>
      )}
    </g>
  );
};

//RADIIIIIII
/*<g className="entalphy">
<clipPath id="myClip">
  <path d="M 0,600 V-1 l800,0  Z" />
</clipPath>

<path
  clip-path="url(#myClip)"
  id="heart"
  fill="none"
  stroke="red"
  d={line()
    .x((d) => xScale(xValue(d)))
    .y((d) => yScale(yValue(d)))
    .curve(curveNatural)(
    data.filter((row) => row.enthalpy === circleRadius)
  )}
/>
*/
